import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';
import './Settings.css';

function SettingsPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const { currentUser } = useAuth();

    // 管理者チェック
    useEffect(() => {
        if (currentUser && !currentUser.is_admin) {
            navigate('/');
        }
    }, [currentUser, navigate]);

    // /settings にアクセスした場合、デフォルトで /settings/users にリダイレクト
    useEffect(() => {
        if (location.pathname === '/settings') {
            navigate('/settings/users', { replace: true });
        }
    }, [location.pathname, navigate]);

    const menuItems = [
        { path: '/settings/users', label: 'ユーザー管理' },
        { path: '/settings/prompts', label: 'プロンプト管理' },
    ];

    return (
        <div className="settings-layout">
            <aside className={`settings-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="settings-sidebar-header">
                    {!sidebarCollapsed && <h2 className="settings-sidebar-title">管理者設定</h2>}
                    <button
                        className="settings-sidebar-toggle"
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        title={sidebarCollapsed ? 'メニューを開く' : 'メニューを閉じる'}
                    >
                        {sidebarCollapsed ? '▶' : '◀'}
                    </button>
                </div>
                <nav className="settings-nav">
                    {menuItems.map(item => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `settings-nav-item ${isActive ? 'settings-nav-item-active' : ''}`
                            }
                            title={sidebarCollapsed ? item.label : ''}
                        >
                            {!sidebarCollapsed && <span className="settings-nav-label">{item.label}</span>}
                        </NavLink>
                    ))}
                </nav>
            </aside>
            <main className="settings-content">
                <Outlet />
            </main>
        </div>
    );
}

export default SettingsPage;
